import { render, staticRenderFns } from "./menberCenter.vue?vue&type=template&id=38a082e5"
import script from "./menberCenter.vue?vue&type=script&lang=js"
export * from "./menberCenter.vue?vue&type=script&lang=js"
import style0 from "./menberCenter.vue?vue&type=style&index=0&id=38a082e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports